// All prices in cents. Fallback defaults — the live menu is fetched from /api/menu.
export const money = (cents) => `$${((cents || 0) / 100).toFixed(2)}`;

export const FLAVOR_OPTIONS = [
  "Hot Cheeto",
  "Elote Blast",
  "Garlic Parmesan",
  "Lemon Pepper",
  "Mango Habanero",
  "Original Buffalo",
  "Salsa Macha",
  "Midnight Mole Bomb",
  "Sonora Hellfire Chiltepin",
  "Spicy Lemon Pepper (Dry Rub)",
  "Cajun (Dry Rub)",
  "Plain",
];

export const SODA_OPTIONS = ["Coke", "Diet Coke", "Sprite", "Dr. Pepper", "Manzanita"];

export const DIP_OPTIONS = ["Ranch", "Blue Cheese", "Macha Ranch", "Habanero Ranch"];

export const COMBO_PRICE = 500; // +$5: adds fries + can soda

// item.type: "protein" (wings/tenders) | "pack" | "drink" | "addon"
export const MENU = {
  packs: {
    title: "Group Packs",
    tag: "feed the crew",
    items: [
      { id: "pack-20", type: "pack", name: "20 PC Pack", price: 2999, flavorPick: 2, sodaPick: 2, saucePick: 2, fries: "1 Fries", desc: "20 wings · 2 flavors · 1 fries · 2 sodas · 2 sauces" },
      { id: "pack-30", type: "pack", name: "30 PC Pack", price: 4499, flavorPick: 4, sodaPick: 3, saucePick: 2, fries: "3 Fries", desc: "30 wings · 4 flavors · 3 fries · 3 sodas · 2 sauces" },
      { id: "pack-50", type: "pack", name: "50 PC Pack", price: 7299, flavorPick: 5, sodaPick: 5, saucePick: 4, fries: "4 Fries", desc: "50 wings · 5 flavors · 4 fries · 5 sodas · 4 sauces" },
      { id: "pack-75", type: "pack", name: "75 PC Pack", price: 9999, flavorPick: 6, sodaPick: 7, saucePick: 6, fries: "6 Fries", desc: "75 wings · 6 flavors · 6 fries · 7 sodas · 6 sauces" },
    ],
  },
  wings: {
    title: "Wings",
    tag: "alitas",
    items: [
      {
        id: "wings", type: "protein", name: "Wings", comboAvailable: true,
        desc: "Fresh, never frozen — tossed in any flavor. Bigger sizes = more flavors!",
        variants: [
          { label: "6 Piece", price: 1199, flavors: 1 },
          { label: "10 Piece", price: 1799, flavors: 2 },
          { label: "20 Piece", price: 2900, flavors: 3 },
          { label: "30 Piece", price: 4299, flavors: 4 },
        ],
      },
    ],
  },
  tenders: {
    title: "Tenders",
    tag: "tenders",
    items: [
      {
        id: "tenders", type: "protein", name: "Tenders", comboAvailable: true,
        desc: "Hand-breaded chicken tenders, cooked to order.",
        variants: [
          { label: "3 Piece", price: 800, flavors: 1 },
          { label: "5 Piece", price: 1400, flavors: 2 },
          { label: "7 Piece", price: 1800, flavors: 3 },
          { label: "10 Piece", price: 2100, flavors: 4 },
        ],
      },
    ],
  },
  fries: {
    title: "Fries & Sides",
    tag: "crispy",
    items: [
      { id: "regular-fries", type: "addon", name: "Regular Fries", price: 300, desc: "Golden & crispy." },
      { id: "sweet-potato-fries", type: "addon", name: "Sweet Potato Fries", price: 400, desc: "Sweet, savory & crispy." },
      { id: "waffle-fries", type: "addon", name: "Waffle Fries", price: 400, desc: "Crispy waffle-cut fries." },
      { id: "loaded-fries", type: "addon", name: "Loaded Fries", price: 999, saucePick: 1, desc: "Waffle fries loaded with our signature toppings — pick your flavor drizzle!" },
    ],
  },
  drinks: {
    title: "Drinks",
    tag: "keep it cold",
    items: [
      { id: "can-soda", type: "drink", name: "Can Soda", price: 200, sodaPick: 1, desc: "Choose your flavor." },
      { id: "bottled-drink", type: "drink", name: "Bottled Drink", price: 400, desc: "Assorted bottled drinks." },
      { id: "bottled-water", type: "drink", name: "Bottled Water", price: 200, desc: "Ice cold water." },
    ],
  },
  addons: {
    title: "Add-Ons & Sauces",
    tag: "dip it",
    items: [
      { id: "large-ranch", type: "addon", name: "Large Ranch (4oz)", price: 300, desc: "Creamy house ranch." },
      { id: "medium-ranch", type: "addon", name: "Medium Ranch (2oz)", price: 200, desc: "Creamy house ranch." },
      { id: "sauce-2oz", type: "addon", name: "2oz Sauce", price: 200, saucePick: 1, desc: "Pick a dipping sauce." },
    ],
  },
};

export const CATEGORY_ORDER = ["packs", "wings", "tenders", "fries", "drinks", "addons"];
